import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "left-aside" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = { class: "footer" }
const _hoisted_4 = { class: "online-players" }
const _hoisted_5 = {
  key: 0,
  class: "count-online-players"
}
const _hoisted_6 = { class: "wrapper" }
const _hoisted_7 = { class: "settings-wrapper" }
const _hoisted_8 = {
  href: "https://discord.gg/gXPXEYsk2M",
  target: "_blank",
  rel: "noopener noreferrer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BloxupLogo = _resolveComponent("BloxupLogo")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_Ping = _resolveComponent("Ping")!
  const _component_Discord = _resolveComponent("Discord")!
  const _component_Support = _resolveComponent("Support")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createVNode(_component_BloxupLogo),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
          return (_openBlock(), _createBlock(_component_MenuItem, {
            key: item.value,
            label: item.name,
            icon: item.icon,
            to: item.to,
            active: _ctx.$route.path.startsWith(`/${item.value}`)
          }, null, 8, ["label", "icon", "to", "active"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.globalConfig.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.globalConfig.data.onlineUsersCount?.toLocaleString()), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Ping),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("global.online_players")), 1)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ellipse" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createElementVNode("a", _hoisted_8, [
            _createVNode(_component_Discord)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: "/support" }, {
            default: _withCtx(() => [
              _createVNode(_component_Support, { color: 'rgb(255 255 255 / 60%)' })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}